export default "__VITE_ASSET__7ef090ad__"